export const SET_TOKEN = "SET_TOKEN";
export const GET_USER_INFO = "GET_USER_INFO";
export const DASHBOARD_MINE = "DASHBOARD_MINE";
export const DASHBOARD_DETAILS = "DASHBOARD_DETAILS";
export const DASHBOARD_Zone = "DASHBOARD_Zone";
export const SET_NEW_ZONE = "SET_NEW_ZONE";
export const UPDATE_ZONE = "UPDATE_ZONE";
export const SELECTED_ZONE = "SELECTED_ZONE";
export const SET_NEW_DASHBOARD = "SET_NEW_DASHBOARD";
export const SET_DEVICE_WIDGETS_DISJOINED = "SET_DEVICE_WIDGETS_DISJOINED";
export const SET_DEVICE_WIDGETS_JOINED = "SET_DEVICE_WIDGETS_JOINED";
export const SET_DEVICE_MINE = "SET_DEVICE_MINE";
export const DEVICE_RENAME = "DEVICE_RENAME";
export const SELECTED_DEVICE_MINE = "SELECTED_DEVICE_MINE";
export const SET_COMMAND_GENERAL = "SET_COMMAND_GENERAL";
export const SET_ZONE_WIDGETS = "SET_ZONE_WIDGETS";
export const SET_INVITATION_LIST = "SET_INVITATION_LIST";
export const SET_INVITED_USER = "SET_INVITED_USER";
export const SET_INVITED_USER_SETTING = "SET_INVITED_USER_SETTING";
export const SET_NEW_INVITATION = "SET_NEW_INVITATION";
export const SET_FOLIO = "SET_FOLIO";
export const SET_SUPPORT_TYPE_LIST = "SET_SUPPORT_TYPE_LIST";
export const SET_SUPPORT_MINE = "SET_SUPPORT_MINE";
export const SET_SCHEDULE_LIST = "SET_SCHEDULE_LIST";
export const SCHEDULE_EDIT = "SCHEDULE_EDIT";
export const SCHEDULE_DELETE = "SCHEDULE_DELETE";
export const RELOCATE_WIDGET = "RELOCATE_WIDGET";
export const RENAME_WIDGET = "RENAME_WIDGET";
export const RENAME_DASHBOARD = "RENAME_DASHBOARD";
export const REMOVE_DASHBOARD = "REMOVE_DASHBOARD";
export const REMOVE_ZONE = "REMOVE_ZONE";
export const SET_ICONS = "SET_ICONS";
export const SET_WIDGET_SERIAL_NUMBERS = "SET_WIDGET_SERIAL_NUMBERS";
export const UPDATE_PROFILE_INFO = "UPDATE_PROFILE_INFO";
